import { partsInZone, todayKey } from '../../../utils/dateTime';
import { activeClientName, activeDbName } from '../../../services/activeDatabase';

/**
 * Build report filename: "Client Name - Report Name[ - Grouped by Label] - YYYYMMDDHHmmss.ext"
 *
 * Client Name is the selected database's organization display name (AppSec_Organizations.DisplayName,
 * e.g. "GF") of this tab's database, stored by DatabaseContext when the slug resolves; the server names subscription
 * and server-built files from the same field.
 * @param {string}  reportName
 * @param {string}  extension
 * @param {string}  [groupByLabel]  — when set, inserts "Grouped by {label}" segment
 */
const buildReportFilename = (reportName, extension, groupByLabel) => {
  const clientName = activeClientName().replace(/[\\/:*?"<>|]/g, '').trim()
    || activeDbName() || 'unknown';

  // The person's local day and clock; seconds are the same in every zone.
  const now = new Date();
  const clock = partsInZone(now);
  const timestamp = todayKey().replace(/-/g, '')
    + String(clock.hour).padStart(2, '0')
    + String(clock.minute).padStart(2, '0')
    + String(now.getSeconds()).padStart(2, '0');

  // Strip only characters illegal in Windows/Mac filenames; preserve hyphens, underscores, etc.
  const safeName = reportName.replace(/[\\/:*?"<>|]/g, '').trim();
  const groupSegment = groupByLabel
    ? ` - Grouped by ${groupByLabel.replace(/[\\/:*?"<>|]/g, '').trim()}`
    : '';

  return `${clientName} - ${safeName}${groupSegment} - ${timestamp}.${extension}`;
};

export default buildReportFilename;
